import { render, staticRenderFns } from "./Sliders.vue?vue&type=template&id=4ae58b2b&scoped=true"
import script from "./Sliders.vue?vue&type=script&lang=js"
export * from "./Sliders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae58b2b",
  null
  
)

export default component.exports